import { makeObservable, flow, observable, action, computed } from "mobx";

import { toast } from "sonner";

import { api } from "@/lib/services";

import { ApiRoutes } from "@/lib/routes";

import DeleteAuditRegistrySchema from "@/areas/settings/schemas/DeleteAuditRegistrySchema";

export default class DeleteAuditRegistryStore {
  visible = false;
  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canDelete: computed,
    });

    this.parentStore = parentStore;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  get canDelete() {
    return;
  }

  *save(data, options) {
    try {
      this.processing = true;

      const parseResult = DeleteAuditRegistrySchema.safeParse(data);
      if (!parseResult.success) {
        return parseResult;
      }

      const response = yield api.delete(ApiRoutes.forAuditRegistry(data.id), { data });
      if (response.status == 204) {
        this.visible = false;
        toast.success("Audit registry deleted successfully");
        return { success: true, data: response.data };
      } else {
        toast.error("Error while deleting audit registry", {
          description: result.message || "Unexpected error, please try again later.",
        });
        return { success: false, data: response.data };
      }
    } catch (e) {
      if (e.response.status == 400) {
        this.visible = false;
        toast.error("Cannot delete this registry", {
          description: e.response.data.message,
        });
      }
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
